<template>
  <div class="flexRow">
    <button class="modal-default-button" v-if="!isLoggedIn" @click="login">
      Login
    </button>

    <!-- FIXME - This is ugly -->
    <div class="profile-data flexRow" v-if="isLoggedIn" @click="logout">
      <div v-if="!isMobile()">
        {{ name }}
      </div>
      <div><img :src="photoURL" /><!-- FIXME - Quota issues and 404ing images --></div>
    </div>
  </div>
</template>

<script>
import auth from "../auth.js";
import util from "../util.js";
import eventHub from "../eventHub.js";

export default {
  name: "user-profile-link",
  mixins: [util.getMobileMixin()],
  data() {
    return {
      isLoggedIn: false,
    };
  },
  beforeCreate() {
    let self = this;
    eventHub.$on("user-logged-in", function() {
      self.$set(self, "isLoggedIn", true);
    });
    eventHub.$on("user-logged-out", function() {
      self.$set(self, "isLoggedIn", false);
    });
  },
  methods: {
    login() {
      auth.signIn();
    },
    logout() {
      let really = confirm("Are you sure you want to sign out?");

      if (really) {
        auth.signOut();
        this.$router.push("/login");
      }
    },
  },
  computed: {
    name() {
      return this.isLoggedIn ? auth.getUser().displayName : "";
    },
    photoURL() {
      return this.isLoggedIn ? auth.getUser().photoURL : "";
    },
  },
};
</script>

<style scoped>
/* FIXME - CHANGE THIS CLASS */
.modal-default-button {
  border-color: transparent;
  width: auto;
}

.modal-default-button:focus {
  outline: none;
}

.profile-data {
  cursor: pointer;
}

.profile-data div {
  display: inline-block;
}

/*.profile-data */
img {
  height: 1.5rem;
  width: 1.5rem;
  margin-top: 0.375rem;
  margin-left: 0.25rem;
}
</style>



// WEBPACK FOOTER //
// UserProfileLink.vue?070a7a1d